import React from "react";

export default function DefaultButton({
    onClick = () => {},
    width = "max-content",
    height = "auto",
    backgroundColor = "black",
    color = "white",
    margin = "0",
    cursor = "pointer",
    children,
    fontSize = 15,
    fontFamily = "decimal book",
    textAlign = "center",
    padding = "0",
}) {
    return (
        <button
            style={{
                fontFamily,
                backgroundColor,
                height,
                width,
                color,
                margin,
                cursor,
                fontSize,
                textAlign,
                padding,
            }}
            onClick={onClick}
        >
            {children}
        </button>
    );
}
